export enum BusinessOnboardingSteps {
  WelcomeToBusiness = 'welcome-to-business',

  CardOwner = 'card-owner',
  BuildCard = 'build-card',
  LockFields = 'lock-fields',
  CreateCard = 'create-card',

  ModifyTemplate = 'modify-template',

  BuildTemplate = 'build-template',
  CompanyColors = 'company-colors',
  SaveTemplate = 'save-template',

  Help = 'help',
}

export enum BusinessOnboardingStepGroups {
  Welcome = 'welcome',
  CreateCard = 'create-card',
  ModifyTemplate = 'modify-template',
}

export function getFormattedStepGroupName(id: string): string {
  switch (id) {
    case BusinessOnboardingStepGroups.Welcome:
      return 'Welcome';
    case BusinessOnboardingStepGroups.CreateCard:
      return 'Create Team Card';
    case BusinessOnboardingStepGroups.ModifyTemplate:
      return 'Customize Template';
    default:
      throw new Error('Step group is not a standardized value');
  }
}
